(() => {
  if (window.dtdWorldsReady) return;
  window.dtdWorldsReady = true;
  let motionPaused = false;
  function motionSetup() {
    const control = document.querySelector('[data-dtd-switch]');
    document.documentElement.dataset.dtdMotion = control?.dataset.motion === 'true' ? 'true' : 'false';
    document.documentElement.dataset.dtdMotionPaused = String(motionPaused);
    const button = document.querySelector('[data-dtd-motion-toggle]');
    if (button) {
      button.setAttribute('aria-pressed', String(motionPaused));
      button.textContent = motionPaused ? 'Resume background motion' : 'Pause background motion';
    }
  }
  function show(world) {
    document.documentElement.dataset.dtdWorld = world;
    document.querySelectorAll('[data-dtd-world-link]').forEach(link => {
      const active = link.dataset.dtdWorldLink === world;
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-dtd-motion-toggle]')) {
      motionPaused = !motionPaused;
      motionSetup();
      return;
    }
    const link = event.target.closest('[data-dtd-world-link]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const world = link.dataset.dtdWorldLink;
    history.pushState({dtdWorld:world}, '', '#' + world);
    show(world);
  });
  function restore() {
    if (location.hash === '#perfume' || location.hash === '#deodorant') show(location.hash.slice(1));
    else if (location.hash.startsWith('#dtd-perfume-')) show('perfume');
    else if (!location.hash || location.hash.startsWith('#dtd-scents-')) show('deodorant');
  }
  window.addEventListener('hashchange', restore);
  window.addEventListener('popstate', restore);
  document.addEventListener('shopify:section:load', () => { show(document.documentElement.dataset.dtdWorld || 'deodorant'); motionSetup(); });
  document.addEventListener('shopify:section:select', event => {
    if (event.target.classList.contains('dtd-perfume-section')) show('perfume');
    if (event.target.classList.contains('dtd-home-section')) show('deodorant');
  });
  show(location.hash === '#perfume' ? 'perfume' : 'deodorant');
  motionSetup();
})();
